export const HOME = '/';

export const SUPPORT = '/colabore';
